export const ONE_DAY_IN_SECONDS = 60 * 60 * 24;
export const ONE_WEEK_IN_SECONDS = ONE_DAY_IN_SECONDS * 7;
export const ONE_MONTH_IN_SECONDS = ONE_DAY_IN_SECONDS * 30;
export const ONE_YEAR_IN_SECONDS = ONE_DAY_IN_SECONDS * 365;

export const ONE_DAY_IN_MILLISECONDS = ONE_DAY_IN_SECONDS * 1000;
export const ONE_WEEK_IN_MILLISECONDS = ONE_WEEK_IN_SECONDS * 1000;
export const ONE_MONTH_IN_MILLISECONDS = ONE_MONTH_IN_SECONDS * 1000;
export const ONE_YEAR_IN_MILLISECONDS = ONE_YEAR_IN_SECONDS * 1000;

export const CART_COOKIE = "ng_cart";
export const CART_EXPIRY = new Date(Date.now() + ONE_YEAR_IN_MILLISECONDS);

export const ADYEN_DONE_COOKIE_A = "ng_adyen_done_a";
export const ADYEN_DONE_COOKIE_B = "ng_adyen_done_b";
export const ADYEN_DONE_COOKIE_EXPIRY = new Date(
  Date.now() + ONE_DAY_IN_SECONDS,
);

export const GIFT_CARD_COOKIE = "ng_gift_card";

export const CLEARANCE_FLAGS = [
  "season-sale",
  "202409-outlet-40",
  "202411-bw-outlet",
  "202412-season-sale-tot",
];

export const FREE_SHIPPING_TRESHOLD = 1000;
